let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lk4cE")).then(() => parcelRequire('1hgMC'));